import React from "react";

import { COLORS } from "@src/constants";
import { CustomCellRendererProps } from "ag-grid-react";
import { Progress } from "antd";
import "./staffing_progress_bar.less";

interface StaffingProgressBarProps {
  props: CustomCellRendererProps;
}

const StaffingProgressBar: React.FC<StaffingProgressBarProps> = ({ props }) => {
  return (
    <div className="staffing-progress-bar">
      Staffing:
      <Progress
        percent={props.value}
        size="small"
        strokeColor={COLORS.BRAND_100}
        format={(percent) => `${percent}%`} // needed to show percentage also when success
      />
    </div>
  );
};

export default StaffingProgressBar;
